import { Flex } from 'foundations-components/components/Flex';
import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import { ErrorBoundary } from '../../../v2/components/error-boundary/ErrorBoundary';
import { APP } from '../../../v2/constants/tracking/TrackingSources';
import LoadingCTA from '../../../features/purchaseMotions/components/LoadingCTA';
import { TalkToSalesFallback } from '../../../features/purchaseMotions/components/TalkToSalesFallback';
import { useBestApiNameFromProductConfigurations } from '../../../hooks/useBestApiNameFromProductConfigurations';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtilsLegacy';
import CodeSplitEnvWrapper from '../../common/env/CodeSplitEnvWrapper';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotCreditsTileCTAs = ({
  screen,
  subscreen,
  purchaseMotions,
  productConfigurations,
  location,
  trackingSource,
  productIdentifier
}) => {
  const isAppReady = useGlobalLoading();
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const widths = purchaseMotions.map(() => '100%');
  const heights = purchaseMotions.map(() => 42);
  const apiName = useBestApiNameFromProductConfigurations(productConfigurations);
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(TalkToSalesFallback, {
      apiName: 'hubspot-credits-committed',
      trackingSource: trackingSource,
      screen: screen
    }),
    children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !isAppReady,
      widths: widths,
      heights: heights,
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "200",
        children: purchaseMotions.map((purchaseMotion, index) => {
          const sharedProps = {
            productConfigurations,
            queryParamTerm,
            trackingSource,
            purchaseMotion
          };
          return /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
              authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
              publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
              authedComponentProps: Object.assign({
                apiName: 'hubspot-credits-committed'
              }, sharedProps, ctaVariantProps, {
                nonMerchandiseIdIdentifier: productIdentifier,
                skipInterstitialPage: true,
                purchaseMotionLocation: location,
                trackingData: {
                  app: APP,
                  screen,
                  subscreen,
                  uniqueId: `${screen}-${apiName}`
                },
                use: index === 0 ? 'primary' : 'secondary'
              }),
              publicComponentProps: Object.assign({}, sharedProps, {
                dtbSource: `pricing-page|${trackingSource}`,
                sourceId: trackingSource,
                nonMerchandiseIdProduct: productIdentifier,
                use: index === 0 ? 'primary' : 'secondary'
              }),
              authedComponentLoadingState: LoadingCTA,
              publicComponentLoadingState: LoadingCTA
            })
          }, String(purchaseMotion));
        })
      })
    })
  });
};
export default HubSpotCreditsTileCTAs;